import Badge from "../../../assets/images/which/badge.gif";
import Tick from "../../../assets/images/which/tick.gif";
import Pound from "../../../assets/images/which/pound.gif";
import Devices from "../../../assets/images/which/devices.gif";

export const FooterImages = {
  1: Badge,
  2: Tick,
  3: Pound,
  4: Devices,
};
